import type { AlertProps } from '@mui/material';
import { useCallback, useState } from 'react';
import type { SnackbarState } from '~/types/Misc';

export const useSnackbar = () => {
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    isOpen: false,
    title: '',
    message: '',
    type: 'info',
  });

  const showSnackbar = useCallback(
    (message: string, type: AlertProps['severity'], title?: string) => {
      if (snackbar.isOpen) {
        return;
      }

      setSnackbar({
        isOpen: true,
        title,
        message,
        type,
      });
    },
    [snackbar.isOpen],
  );

  const closeSnackbar = useCallback(() => {
    if (!snackbar.isOpen) {
      return;
    }

    setSnackbar((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }, [snackbar.isOpen]);

  const updateSnackbar = useCallback((message: string, type?: AlertProps['severity'], title?: string) => {
    setSnackbar((prev) => ({
      ...prev,
      title,
      message,
      type,
    }));
  }, []);

  return {
    snackbar,
    showSnackbar,
    closeSnackbar,
    updateSnackbar,
  };
};
